<script>
export default {
    name: "ProformaItemsImport",

    props: {

        showModal: Boolean,
        items: Array,
        invoice: Object,
        patient: Object,
    },

    computed: {

        importData() {
            
            return {
                invoiceNo: this.invoice.invoiceNo,
                proformaBillItems: this.items.filter(item => item.check).map(item => ({
                    proformaInvoiceDetailID: item.invoiceDetailID,
                    invoiceDetailID: 0,
                    patientID: item.patientID,
                    visitNo: item.visitNo,
                    consultantID: 0,
                    itemId: item.itemID,
                    itemName: item.item,
                    qty: item.qty,
                    storeId: 0,
                    amountCharged: item.charge,
                    discount: 0,
                    tax: 0,
                    txnDate: window.moment().format(`YYYY-MM-DD`),
                    description: item.description,
                    ref: item.ref,
                    userName: this.$root.username,
                })),
            };
        },
    },

    methods: {

        importProforma() {

            this.$root.loading=true;
            this.$http.post(`Accounts/ImportProformaInvoice`, this.importData).then(({data}) => {
                this.$emit(`refresh`);
                this.$root.loading=false;
                this.$emit(`closeModal`);
                window.Swal.fire({ type: `success`, text: data, });
            }).catch(() => {this.$root.loading=false;});
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-2/3 sm:w-11/12">
      <template v-slot:title>
        <h5 class="font-bold text-sm">Proforma Invoice</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap items-center">
            <div class="w-full flex flex-row p-1 bg-gray-300 my-2">
                <div class="flex-1">
                    <h5 class="text-sm font-medium">Name: {{patient.names}}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="text-sm font-medium">MRN: {{patient.patienT_ID}}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="text-sm font-medium">OP: {{patient.opfileno}}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="text-sm font-medium">IP: {{patient.ipfileno}}</h5>
                </div>
            </div>
            <div class="w-full flex flex-row p-1 bg-gray-300 my-2">
                <div class="flex-1">
                    <h5 class="text-sm font-medium">Date: {{invoice.trxDate | dateFormat}}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="text-sm font-medium">Invoice No: {{invoice.invoiceNo}}</h5>
                </div>
            </div>
            <div class="w-full overflow-auto p-1">
                <table class="table">
                    <thead class="bg-blue-500 text-white text-xs">
                        <tr>
                            <th class="p-tiny">Id</th>
                            <th class="p-tiny">Bill No</th>
                            <th class="p-tiny">Item</th>
                            <th class="p-tiny">Description</th>
                            <th class="p-tiny">Qty</th>
                            <th class="p-tiny">Price</th>
                            <th class="p-tiny">G Total</th>
                            <th class="p-tiny">Select</th>
                        </tr>
                    </thead>
                    <tbody class="text-xs bg-gray-100">
                        <tr v-for="item in items" :key="item.invoiceDetailID">
                            <td class="p-tiny">{{item.invoiceDetailID}}</td>
                            <td class="p-tiny">{{item.billNo}}</td>
                            <td class="p-tiny">{{item.item}}</td>
                            <td class="p-tiny">{{item.description || `-`}}</td>
                            <td class="p-tiny">{{item.qty}}</td>
                            <td class="p-tiny">{{item.charge}}</td>
                            <td class="p-tiny">{{item.grandTotal | numberFormat}}</td>
                            <td class="p-tiny">
                                <input type="checkbox" v-model="item.check" class="w-4 h-5">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-6" 
          @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
        <button @click.prevent="importProforma" class="btn-primary btn-sm text-xs rounded">
            <i class="fa fa-download"></i> Import Items To Bill</button>
      </template>
    </tail-modal>
</template>